import listParser from './parsers/list';
import toError from './parsers/error';

import { lists as externalListsRequests } from './external-requests';

import * as http from '../../utils/http';


const defaultPaging = {
  size: 30,
  cursor: null,
};

const defaultSort = {
  order: 'date',
  direction: 'desc',
};


export default function (settings, adapterMethods) {

  const toList = _.partial(listParser, adapterMethods);


  function list(trigger, options = {}) {
    const { query, tag, category, noExternalData = false, mediaType = settings.mediaType } = options;
    let { sort, paging } = options;
    sort = _.merge({}, defaultSort, sort);
    paging = _.merge({}, defaultPaging, paging);

    const { size, cursor } = paging;
    const { direction, order } = sort;

    const params = {
      query,
      tag,
      category,
      media_type: mediaType,
      page_size: size,
      cursor,
      order: direction === 'desc' ? `-${order}` : order,
    };

    return http.get(`${settings.apiUrl}/catalog/lists`, { params })
      .then(function (response) {
        const { data } = response;

        let parsedListItems = _.map(data.items, toList);

        if (noExternalData) {
          return _buildResponse();
        }

        const externalRequestsOptions = { shouldThrowWhenNoItems: false };

        const externalRequests = _(parsedListItems)
          .groupBy(item => `${item.channelType}.${item.urlType}`)
          .map(function (items, key) {
            const ids = _.map(items, 'externalId');
            const requestMethod = externalListsRequests[key];

            if (!requestMethod) {
              return null;
            }

            return requestMethod(ids, externalRequestsOptions);
          })
          .compact()
          .value();

        return Promise.all(externalRequests)
          .then(function (externalResponses) {

            externalResponses = _.flatMap(externalResponses, 'data');

            parsedListItems = _.map(parsedListItems, function (listItem) {
              const externalData = _.find(externalResponses, function ({ externalId }) {
                return listItem.externalId && listItem.externalId === externalId;
              });

              if (!externalData) {
                return listItem;
              }

              return {
                ...listItem,
                ..._.omit(externalData, 'id', 'title', 'description'),
              };
            });

            return _buildResponse();
          });


        function _buildResponse() {
          return _.assign({}, response, {
            sort,
            paging: {
              size,
              cursor: data.cursor || null,
            },
            data: parsedListItems,
          });
        }
      })
      .catch(toError);
  }


  function search(trigger, query, options = {}) {
    return list(trigger, { ...options, query });
  }


  function remove(trigger, itemId) {
    return http.del(`${settings.apiUrl}/catalog/lists/${itemId}`)
      .catch(toError);
  }


  return {
    list,
    search,
    remove,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/lists.js